import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Card, CardBody, Row, Col, Input, Button, Table } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { fetchHrmsSponsor, updateSponsorStatus } from "../../services/Hrms/hrms"
import { toastError, toastSuccess } from "../../helpers/msg_helper"
import "../Tenancy/tenancy.css"

/**
 * Administration → Sponsors: the full sponsor master. Add/Edit open a separate page
 * (StaffFlow parity); the list uses iconic row actions.
 */
const Sponsors = () => {
  document.title = "Sponsors | Calyvern"
  const navigate = useNavigate()
  const [rows, setRows] = useState([])
  const [search, setSearch] = useState("")
  const [refresh, setRefresh] = useState(0)

  useEffect(() => {
    ;(async () => {
      try {
        const r = await fetchHrmsSponsor({ params: `searchText=${search}&sizePerPage=100` })
        setRows(r?.data?.data || [])
      } catch (e) { toastError(e?.message) }
    })()
  }, [search, refresh])

  const toggleStatus = async s => {
    try { const r = await updateSponsorStatus(s.id); toastSuccess(r?.message); setRefresh(n => n + 1) }
    catch (e) { toastError(e?.message) }
  }

  return (
    <div className="page-content tnt-scope">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center">
          <Breadcrumbs title="Administration" breadcrumbObject={[
            { title: "Administration", link: "#" },
            { title: "Sponsors", link: "#" },
          ]} />
          <Button color="primary" className="mb-3" onClick={() => navigate("/admin/sponsors/create")}>+ Sponsor</Button>
        </div>
        <Card className="tnt-page-card me-2 px-2 pb-2 main-dashboard-bg">
          <CardBody>
            <Row className="mb-2"><Col md={4}>
              <Input bsSize="sm" placeholder="Search sponsors…" value={search} onChange={e => setSearch(e.target.value)} />
            </Col></Row>
            <Table responsive borderless className="align-middle tnt-table">
              <thead><tr><th>Code</th><th>Name</th><th>Type</th><th>Nationality</th><th>Phone</th><th>Status</th><th className="text-end">Actions</th></tr></thead>
              <tbody>
                {rows.map(s => (
                  <tr key={s.id}>
                    <td>{s.code || "—"}</td>
                    <td>{s.sponsored_by}</td>
                    <td className="text-capitalize">{s.sponsor_type || "individual"}</td>
                    <td>{s.nationality || "—"}</td>
                    <td>{s.contact_phone || "—"}</td>
                    <td>{s.status ? <span className="badge bg-success">Active</span> : <span className="badge bg-secondary">Inactive</span>}</td>
                    <td className="text-end text-nowrap">
                      <i className="uil-pen action-icon" role="button" title="Edit" onClick={() => navigate(`/admin/sponsors/${s.id}/edit`)} />
                      <i className={`uil-${s.status ? "ban" : "check-circle"} action-icon ${s.status ? "danger" : ""}`} role="button" title={s.status ? "Deactivate" : "Activate"} onClick={() => toggleStatus(s)} />
                    </td>
                  </tr>
                ))}
                {!rows.length && <tr><td colSpan="7" className="text-center text-muted">No sponsors yet.</td></tr>}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default Sponsors
